import { render, staticRenderFns } from "./ReplicantiTab.vue?vue&type=template&id=0a018ecd&scoped=true"
import script from "./ReplicantiTab.vue?vue&type=script&lang=js"
export * from "./ReplicantiTab.vue?vue&type=script&lang=js"
import style0 from "./ReplicantiTab.vue?vue&type=style&index=0&id=0a018ecd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a018ecd",
  null
  
)

export default component.exports